import {Card} from "../../../@types/buildingOnlineAdvantagesCardsResources.tsx";
import {Trans, useTranslation} from "react-i18next";

const AdvantageCard = ({card}: {card: Card}) => {

    const {t} = useTranslation();

    return (
        <>
            <div className="pricing-advantage-card col-md-4 mb-4">
                <img className="mb-3" src={card.image} alt='advantage logo' />
                <Trans t={t}>
                    <p className="text-blue-dark">{t(card.description)}</p>
                </Trans>
            </div>
        </>
    )
}

export default AdvantageCard;
